var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIstioLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 240",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#466BB0",
    d: "M0 0h160v240H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 210h160L60 240zM0 200l60-10V80zM70 190l90 10L70 0z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDE2MCAyNDAiPjxnIGlkPSJsb2dvIiBmaWxsPSIjZmZmIj48cmVjdCBpZD0iYmFja2dyb3VuZCIgd2lkdGg9IjE2MCIgaGVpZ2h0PSIyNDAiIGZpbGw9IiM0NjZCQjAiLz48cG9seWdvbiBpZD0iaHVsbCIgcG9pbnRzPSIwIDIxMCAxNjAgMjEwIDYwIDI0MCIvPjxwb2x5Z29uIGlkPSJtYWluc2FpbCIgcG9pbnRzPSIwIDIwMCA2MCAxOTAgNjAgODAiLz48cG9seWdvbiBpZD0iaGVhZHNhaWwiIHBvaW50cz0iNzAgMTkwIDE2MCAyMDAgNzAgMCIvPjwvZz48L3N2Zz4=";
export { SvgIstioLogo as ReactComponent };